import React from 'react';
const comparisonRows = [{
  without: 'Dudás qué hacer',
  with: 'Actuás con claridad'
}, {
  without: 'Improvisás',
  with: 'Seguís un proceso'
}, {
  without: 'Tenés miedo a equivocarte',
  with: 'Ganás seguridad'
}, {
  without: 'Todo es confuso',
  with: 'Tenés control'
}];
export function ComparisonTableExtended() {
  return <section className="bg-transparent text-white py-5 px-5" data-id="element-81">
      <div className="max-w-xl mx-auto" data-id="element-82">
        <h3 className="text-base md:text-lg font-black text-white mb-4 flex items-center gap-2" data-id="element-83">
          🧠 TABLA COMPARATIVA
        </h3>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-84">
          <div className="text-xs font-bold text-red-400 flex items-center gap-1" data-id="element-85">
            ❌ Sin sistema
          </div>
          <div className="text-xs font-bold text-green-400 flex items-center gap-1" data-id="element-86">
            ✅ Con sistema
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2" data-id="element-87">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-3 border-t border-white/10 pt-3" data-id="element-88">
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-89">
                {row.without}
              </p>
              <p className="text-xs text-gray-300 leading-relaxed" data-id="element-90">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}